<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">ACKNOWLEDGEMENTS</p>
<p class="noindent">Jeff Campbell would like to thank:</p>
<p class="indent">Mary Jacobs for editing this book.</p>
<p class="indent">Hunter Herring for writing the story “Railway Employees: Into the Jaws of Death,” researching “New Number Same Result” and writing “The 1914 Woodlake Interurban Wreck.”</p>
<p class="indent">Austin Ng for researching and writing “The Mystery of John H. Dillehay’s Death” and researching for “The Costs of Cost Cutting.”</p>
<p class="indent">Debbie Calvin for her assistance in assembling the <i>Mayhem on the Interurban</i> exhibit for the Interurban Railway Museum and the photographic research for this book.</p>
<p class="indent">Druce Reiley Associates and the creative team at the Interurban Railway Museum for the museum exhibit <i>Mayhem on the Interurban</i>.</p>
<p class="indent">Cheryl Smith and the Haggard Library for their research assistance.</p>
<p class="indent">Harold Larson, president of the board of the Plano Conservancy for Historic Preservation, for his support of this project.</p>
<p class="indent">And <a href="http://www.Newspapers.com" target="_blank">Newspapers.com</a>, an excellent resource for anyone conducting historical research.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?4471a99f